jQuery.widget("common.VisualBaseFunctions", {

    fnd: function (selector) {
      
        return this.visual.find(selector);
    },
    initCalendar: function (obj) {
        /// <summary>
        /// This function inits a basic jquery-ui datepicker.
        /// </summary>

        obj.datepicker({ changeMonth: true, changeYear: true, showButtonPanel: true, showOn: 'button', buttonImage: '../../images/visualcore/calendar.gif', buttonImageOnly: true });
    },
    initIntervalCalendar: function (from, to, limit, onSelect) {
        /// <summary>
        /// This function is used to connect two date calenders together.<br/>
        /// </summary>
        from.datepicker({
            changeMonth: true, changeYear: true,
            showButtonPanel: true, showOn: 'button', buttonImage: '../../images/visualcore/calendar.gif', buttonImageOnly: true,
            onClose: function (selectedDate) { to.datepicker("option", limit, selectedDate); },
            onSelect: function () {
                onSelect();
            }
        });
    },
    navigateDate: function (obj, interval) {
        /// <summary>
        /// This function increases the date of an date input field by the given interval.
        /// </summary>
        var dt = $.datepicker.parseDate('dd.mm.yy', obj.val());
        dt.setDate(dt.getDate() + interval);
        obj.datepicker('setDate', dt);
    },    
    setTagFilter: function (filterObj, listItem, classFound) {
        /// <summary>
        /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
        /// It is used as part of the filter function in vc-lists
        /// </summary>
        var me = this;
        try {


            if (me.visual.find(filterObj + " .floatbox").length > 0) {
                //we reset the counter for found entries
                me.visual.find(listItem).data('counter', 0);

                //we filter the optional tags we got from the vc-tags
                var filter = me.visual.find(filterObj).vcFilter("getFilter");

                if (filter !== null) {
                    var counter;
                    //first, we count how often we find the filter tags in every signal item
                    for (var i = 0; i <= filter.length - 1; i++) {
                        if (filter[i].length > 0) {
                            me.visual.find(listItem + ":contains('" + filter[i] + "')")
                                .each(function () {
                                    counter = parseInt($(this).data('counter'), 10);
                                    if (isNaN(counter)) {
                                        counter = 0;
                                    }
                                    counter++;
                                    $(this).data('counter', counter);

                                });
                        }
                    }
                    //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
                    //why? if we have several filter tags we have to find all of them in one single signal 
                    me.visual.find(listItem)
                        .each(function () {
                            if (parseInt($(this).data("counter"), 10) === filter.length) {
                                $(this).addClass(classFound);
                            }
                        });
                } else {
                    me.visual.find(listItem).addClass(classFound);
                }
            }
        } catch (ex) {
            writeError(me.source + '.JS.setTagFilter', ex);
        }
    },
    openAskDialog: function (caption, posUser, yes, no, canc) {
        /// <summary>
        /// This function opens a dialog popup for common validation usage.
        /// yes, no, cancel are functions which get executed 
        /// pos can add specific position settings eg: of: target! - fixes position to target
        /// </summary>
        var me = this;
        var posDefault;
        var pos;
        var canc1;
        try {
            caption += "";
            posDefault = { my: 'top+20%', at: 'top', of: window };
            pos = $().extend({}, posDefault, posUser);

            if (typeof (yes) === "undefined") {  yes = function () { } }
            if (typeof (no) === "undefined") { no = function () { } }
            if (typeof (canc) === "undefined") { canc1 = function () { } } else { canc1 = canc }

            var parentDialog = me.visual ? me.visual.closest(".ui-dialog.modal-popup-dialog") : $();


            var d = $('<p>' + caption + '</p>').dialog({
                position: pos,
                title: me.resources.dialogTitle, modal: true,
                buttons: {
                    "Yes": function () { yes(); d.dialog('close'); return true; },
                    "No": function () { no(); d.dialog('close'); return false; },
                    "Cancel": function () { canc1(); d.dialog('close'); return false; }
                },
                dialogClass: 'saveDialog',
                open: function () {
                    if (parentDialog && parentDialog.length) {
                        var cnt = parentDialog.data("dimCount") || 0;
                        cnt++;
                        parentDialog.data("dimCount", cnt);
                        parentDialog.css("opacity", 0.2);
                    }
                },
                close: function () {
                    if (parentDialog && parentDialog.length) {
                        var cnt = parentDialog.data("dimCount") || 0;
                        cnt = Math.max(0, cnt - 1);
                        parentDialog.data("dimCount", cnt);
                        if (cnt === 0) {
                            parentDialog.css("opacity", 1);
                        }
                    }
                }
            });

            if (typeof (canc) === "undefined") { $('.saveDialog .ui-button-text:contains(CANCEL)').hide(); }

            // ReSharper disable InvalidValue
            $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
            $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
            $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
            // ReSharper restore InvalidValue
            return true;
        } catch (ex) { me.writeError('openAskDialog', ex); return false; }
    },


    openInfoDialog: function (caption, posUser, ok) {
        /// <summary>
        /// This function opens a dialog popup for common validation usage.
        /// yes, no, cancel are functions which get executed 
        /// pos can add specific position settings eg: of: target! - fixes position to target
        /// </summary>
        var me = this;
        var posDefault;
        var pos;
        try {
            caption += "";
            posDefault = { my: 'top+20%', at: 'top', of: window };
            pos = $().extend({}, posDefault, posUser);

            if (typeof (ok) === "undefined") {
                ok = function () { }
            }

            // get parent dialog if exists to blur it while info dialog is open
            var parentDialog = me.visual ? me.visual.closest(".ui-dialog.modal-popup-dialog") : $();

            var d = $('<p>' + caption + '</p>').dialog({
                position: pos,
                title: me.resources.dialogTitle, modal: true,
                buttons: {
                    "OK": function () { ok(); d.dialog('close'); return true; }

                },
                dialogClass: 'saveDialog',
                open: function () {
                    if (parentDialog && parentDialog.length) {
                        var cnt = parentDialog.data("dimCount") || 0;
                        cnt++;
                        parentDialog.data("dimCount", cnt);
                        parentDialog.css("opacity", 0.2);
                    }
                },
                close: function () {
                    if (parentDialog && parentDialog.length) {
                        var cnt = parentDialog.data("dimCount") || 0;
                        cnt = Math.max(0, cnt - 1);
                        parentDialog.data("dimCount", cnt);
                        if (cnt === 0) {
                            parentDialog.css("opacity", 1);
                        }
                    }
                }
            });

            return true;
        } catch (ex) { me.writeError('openInfoDialog', ex); return false; }
    },


    _initEditDialog: function (widthInPercent, heightInPercent, myClass, onClose, bhideCloseBtn) {
        /// <summary>
        /// This function inits the edit dialog for later use. 
        /// </summary>
        var me = this;
        var h, w;
        try {
            me.editDialog = null;
            me.myDiv = $("<div>").attr("id", "div-dialog").css("z-index", 10000);
            if (typeof (myClass) !== "undefined") {
                me.myDiv.addClass(myClass);
            }
           
            var size = me.getPopupSize(widthInPercent, heightInPercent);
            var w = size[0];
            var h = size[1];
          
            var options = {
                autoOpen: false,
                width: w,
                height: h,
                modal: true,
                dialogClass: "modal-popup-dialog",   // "modal-popup-dialog"

            };
          
            if (!bhideCloseBtn) {
             
                options.buttons = [{
                    text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                        me.editDialog.dialog('close');
                        if (typeof (onClose) !== "undefined") onClose();
                        return true;
                    }
                }];
            }

            me.editDialog = me.myDiv.dialog(options);

            me.editDialog.width = w;
            me.editDialog.height = h;

            return true;
        } catch (ex) {
            me.writeError('initEditDialog', ex);
            return false;
        }
    },


    openHtmlCleanupDialog: function () {
        /// <summary>
        /// This function opens a dialog popup for cleaning invalid html in the cleditor.
        /// yes, cancel are functions which get executed 
        /// </summary>
        var me = this;
        var posDefault;
        var pos;
        try {
          
            var randomId = Math.floor(Math.random() * 1000);

            posDefault = { my: 'top+20%', at: 'top', of: window };
            pos = $().extend({}, posDefault, { at: 'center center-20%', of: window });

            var d = $('<p><textarea id="area-html-cleanup' + randomId + '" style="width:480px; height:280px"></textarea></p>').dialog({
                position: pos,
                title: window._RESOURCES.JS_Com.cleanHtmlCaption,
                width: 500,
                height: 400,
                modal: true,
                buttons: {
                    "Yes": function () {
                        $("#area-html-cleanup" + randomId).select();
                        var successful = document.execCommand('copy');
                        d.dialog('close'); return true;
                    },
                    "Cancel": function () { d.dialog('close'); return false; }
                },
                dialogClass: 'saveDialog'
            });
            // ReSharper disable InvalidValue
            $('.saveDialog .ui-button-text:contains(YES)').text(window._RESOURCES.JS_Com.cleanHtmlBtnYes);
            $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
            // ReSharper restore InvalidValue
            return true;
        } catch (ex) { me.writeError('openHtmlCleanupDialog', ex); return false; }
    },


    showInfo: function (content, subcontent, bError) {
        /// <summary>
        /// This function extends the basic showMessage() function with optional subcontent and specific style..
        /// </summary>
        var me = this;
        try {
            if (content.length === 0) {
                me.visual.find('#info').hide();
                me.visual.find('#info div').removeClass('note').removeClass('error').hide();
                return true;
            }
            me.visual.find('#info').show();
            if (bError) {
                me.visual.find('#info div').removeClass('note').addClass('error').show();
                content = "<span class='main'>" + content + "</span><br/><span class='sub'>" + subcontent + "</span>";
                me.visual.find('#info div').html(content);
            } else {
                me.visual.find('#info div').removeClass('error').addClass('note').html(content).show();
            }
            me.specificInfoHandling(bError);
            return true;
        } catch (ex) { writeError(me.source + '.JS.showInfo', ex); return false; }
    },
    specificInfoHandling: function (bError) {
        return true;
    },
    showMessage: function (content, bError) {
        var me = this;
        try {
           
            if (bError === false) {
                me.showInfo(content, "", false);
            } else {
                me.error = true;
                if (typeof (me.resources.err_sub) === "undefined") {
                    me.showInfo(content, me.resources.err_sub_default, true);
                } else {
                    me.showInfo(content, me.resources.err_sub, true);
                }
            }
            return false;
        } catch (ex) {
            writeError(me.source + '.JS.showMessage', ex);
            return false;
        }
    },
    writeError: function (source, ex) {
        var me = this;
        try {
           
            console.info(ex);
            me.error = true;
            me.showMessage(me.resources.err_code, true);
            writeError(me.source + ".JS." + source, ex); 
            return false;
        } catch (ex) {
            me.error = true;
            writeError(me.source + '.JS.writeError', ex);
            return false;
        }
    },
    _writeErr: function (ex) {
        var me = this;
        try {
          
            let source = me._writeErr.caller.name;
            me.error = true;
            console.info(ex);
            me.showMessage(me.resources.err_code, true);
            writeError(me.source + ".JS." + source, ex);
            return false;
        } catch (ex) {
            me.error = true;
            writeError(me.source + '.JS.writeError', ex);
            return false;
        }
    },
    //should get deprecated
    getRandomIDContainerObj: function (objName, bShowLoadingIcon) {
        /// <summary>
        /// This function generates a simple div with a random suffix to the object name.<br/>
        /// Optionally, a loading icon get set as well.
        /// </summary>
        var me = this;
       
        try {
            var random = parseInt(Math.random() * 100000, 10);
            var container = $("<div>").attr("id", objName + random);


            //TODO: me.vcC gibts nicht!!!!
            //if (bShowLoadingIcon) {
            //    container.html(me.vcC.getLoadingIcon());
            //}

            return { "obj": container, "random": random, "prefix": objName }
        } catch (ex) {
            writeError(me.source + '.JS.getRandomIDContainerObj', ex);
            return null;
        }
    },
    //refactored
    showDevIcon: function (imgName) {
        /// <summary>
        /// This function adds an icon for showing the development state (dev, beta, new) at the left top corner of a widget - hopefully.
        /// </summary>
        var me = this;
        try {
            if (imgName.length === 0) { return false; }

            var devIconContainerStyles = {
                position: "absolute",
                top: "-5px",
                left: "-5px",
                width: "36px",
                height: "36px"
            };
            var devIconImageStyles = {
                width: "36px",
                height: "36px"
            };
            var imagePath = "../../images/" + imgName + ".png";

            var html = $("<div>");
            html.css(devIconContainerStyles);

            html.append($("<img>"));
            html.find("img").attr("src", imagePath);
            html.find("img").css(devIconImageStyles);

            me.visual.append(html);
            return false;
        } catch (ex) {
            writeError(me.source + '.JS.showDevIcon', ex);
            return false;
        }
    },
    getCurrentTimestamp: function () {
        return moment().format("DD.MM.YYYY HH:mm:ss");
    },
    //new
    getLoadingIcon: function () {
        var html = $("<div>");
        var htmlImg = $("<img>");
        htmlImg.attr("src", "../../images/visualcore/loading.gif");
        htmlImg.css("height", "15px");
        htmlImg.attr("alt", window._RESOURCES.JS_Com.loading_lbl);
        html.append(htmlImg, window._RESOURCES.JS_Com.loading_lbl);

        return html.html();
    },
    formatNumber: function (number, digits) {
        /// <summary>
        /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
        /// </summary>
        var me = this;
        var rgxNumberDisplayFormat = RegExp("[0-9]*\,[0-9]{" + digits + "}");
        var rgxIsCommaExistent = RegExp(".*\,.*");
        try {
            if (me.error || number.toString().length < 1) { return false; }
            var fraction;

            if (rgxIsCommaExistent.test(number)) {
                fraction = String(number).split(",")[1];
                number = String(number).split(",")[0];

                if (fraction.length > digits) {
                    fraction = fraction.substring(0, digits);
                }

                number = parseFloat(number).toLocaleString("de-DE");
                number = number + "," + fraction;

                while (!rgxNumberDisplayFormat.test(number)) {
                    if (!rgxIsCommaExistent.test(number)) {
                        number += ",";
                    }
                    number += "0";
                }
                return number;
            }

            number = parseFloat(number).toLocaleString("de-DE");
            while (!rgxNumberDisplayFormat.test(number)) {
                if (!rgxIsCommaExistent.test(number)) {
                    number += ",";
                }
                number += "0";
            }

            return number;
        } catch (ex) { me.writeError('filter', ex); return false; }
    },

    getData: function (param, callback) {
        /// <summary>
        /// This function internally sends a getData request to the visualcoreservice  <br/>
        /// arguments: JSON param, callback function 
        /// </summary>
        var me = this;
         //try if param is a valid json
        var sParam;
        try {
          
            var sParam = JSON.stringify(param);
           
        } catch (e) {
            sParam = param;
        }
        try {

            //console.info("GET DATA");
            //console.info(me.settings);

            window.VisualCoreService.getData1(me.options.invoke.vcvid, me.vcgid, me.getCurrentTimestamp(), 0, 0, JSON.stringify(me.settings.parameter), JSON.stringify(me.settings.signalParameter), me.settings.deviceType, me.settings.langID,me.settings.blid,  sParam, callback);


        } catch (ex) {me.writeError('getData', ex); return false; }
    },
    updateData: function (param, callback) {
        /// <summary>
        /// This function internally sends a updateData request to the visualcoreservice  <br/>
        /// arguments: JSON param, callback function 
        /// </summary>
        var me = this;
        //try if param is a valid json
        try {
            var x = JSON.parse(JSON.stringify(param));
            sParam = JSON.stringify(param);
        } catch (e) {
            sParam = param;
     
        }
        try {
          
            window.VisualCoreService.updateData1(me.options.invoke.vcvid, me.vcgid, me.getCurrentTimestamp(), 0, 0, JSON.stringify(me.settings.parameter), JSON.stringify(me.settings.signalParameter), me.settings.deviceType, me.settings.langID, me.settings.blid, sParam,  callback);


        } catch (ex) { me.writeError('updateData', ex); return false; }
    },
    exportData: function (param, callback) {
        /// <summary>
        /// This function internally sends a exportData request to the visualcoreservice  <br/>
        /// arguments: JSON param, callback function 
        /// </summary>
        var me = this;
        //try if param is a valid json
        try {
            var x = JSON.parse(JSON.stringify(param));
            sParam = JSON.stringify(param);
        } catch (e) {
            sParam = param;

        }
        try {
          
            window.VisualCoreService.exportData1(me.options.invoke.vcvid, me.vcgid, me.getCurrentTimestamp(), 0, 0, JSON.stringify(me.settings.parameter), JSON.stringify(me.settings.signalParameter), me.settings.deviceType, me.settings.langID, me.settings.blid, sParam,callback  );


        } catch (ex) { me.writeError('exportData', ex); return false; }
    },


    getPopupSize: function (factorW, factorH) {
        /// <summary>
        /// This function gets the popup size for a full screen popup
        /// </summary>
        var me = this;
        try {
            var size = [];
            var h = 0;
            var w = 0;

            //get the windows height for our popup
            h = $(window).height();
            if (h === 0) {
                h = $(document).height();
                if (h === 0) { h = document.body.scrollHeight; }
            }

            w = parseInt($(window).width() * factorW);
            h = parseInt(h * factorH);

            size.push(w, h);
            return size;

        } catch (ex) { me.writeError('getPopupSize', ex); return false; }
    } 
  
});

jQuery.widget("common.VisualBase", jQuery.common.VisualBaseFunctions, {
  
    options: {
        invoke: {
            type: "addVisual",
            name: "",
            vcgid: Math.floor(Math.random() * Math.floor(100000)),
            vcvid: undefined,
            date: moment().format("DD.MM.YYYY HH:mm:ss"),
            parameter: {},
            signalParameter: {},
            deviceType: 1,
            debug: false,
            callback: undefined,
            onError: undefined,
            blid:undefined,
            showFullscreen: false,
            showHeaderMenu: false
        }
    },
    container: {
        id: undefined,
        height: undefined,
        width: undefined,
        contentHeight: undefined
    },
    settings: {
        mobile: undefined,
        devicetype: undefined,
        userlang: undefined,
        userlangforculture: undefined,
        lang: undefined,
        blid: undefined,
        Date: undefined,
        parameter: undefined,
        signalParameter: undefined
    },
    data: {

    },
    resources: {  },
    specific: {},
   
    _create: function () {
        return true;
    },



    _init: function () {
        var me = this;


    

        this.options.invoke = $.extend({}, this.options.invoke, this.options);

        this.options.invoke.container = this.container = {
            id: this.element.attr("id"),
            height: parseInt(this.element.height()),
            width: parseInt(this.element.width())
        };
        this.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
       
        this.options.invoke.callback = function () {me._initVisualBase();};
        this.element.vcInvoke(this.options.invoke);
     
        return true;
    },
    _initVisualBase: function () {
        var me = this;
        var vData;
    
      
            me.visual = $("#" + "divVC" + me.options.invoke.vcgid);


        vData = me.visual.data("visualdata");


            me.visual.removeAttr("data-visualdata");

            me.visual.prepend($("<div>").attr("id", "info").append($("<div>")));
            me.visual.find("#info").hide();

        if (typeof (vData) === "undefined") {  return;}

            me.settings = {};
       
            me.settings.blid = vData.BLID;
            me.settings.langID = vData.LangID;
            me.settings.userLangID = vData.UserLangID;
            me.settings.userLangIDForCulture = vData.UserLangIDForCulture;
            me.settings.mobile = vData.Mobile;
            me.settings.deviceType = me.options.invoke.deviceType;

            me.settings.date = me.options.date;
            me.settings.parameter = me.options.invoke.parameter;
            me.settings.signalParameter = me.options.invoke.signalParameter;

            me.container.contentHeight = vData.ContentHeight;

            me.source = vData.Source;
            me.specific = vData.Specific;
            me.vcvid = vData.VCVID;
            me.vcgid = me.options.invoke.vcgid;


            me._initResources();


            me._initHTML();
       
            me._initEvents();

    },

    _initResources: function () {
      
        var me = this;
      
        me.resources.selection = _RESOURCES.JS_Com.selection ;
        me.resources.status = _RESOURCES.JS_Com.status;
        me.resources.err_sub = _RESOURCES.JS_Com.err_sub;
        me.resources.err_code = _RESOURCES.JS_Com.err_code;
        me.resources.err_loadData = _RESOURCES.JS_Com.err_loadData;
        me.resources.err_saveData = _RESOURCES.JS_Com.err_saveData;
        me.resources.noEntriesExist = _RESOURCES.JS_Com.noEntriesExist;
        me.resources.dialogTitle = _RESOURCES.JS_Com.dialogTitle;
        me.resources.yes = _RESOURCES.JS_Com.yes;
        me.resources.no = _RESOURCES.JS_Com.no;
        me.resources.cancel = _RESOURCES.JS_Com.cancel_lbl;

        return true;
    },


    _debugWrap(fn, fnName) {
        if (fn._isWrapped) return fn;

        const hash = [...fnName].reduce((acc, c) => acc + c.charCodeAt(0), 0);
        const hue = hash % 360;
        const color = `hsl(${hue}, 60%, 50%)`;

        const wrappedFn = function (...args) {
            const start = performance.now();
            console.info(`%c[DEBUG] ⏱ Start: ${fnName} @ ${moment().format("mm:ss:SSS")}`, `color: ${color}; font-weight: bold`);
            const result = fn.apply(this, args);
            const end = performance.now();
            console.info(`%c[DEBUG] ✅ End:   ${fnName} — Duration: ${(end - start).toFixed(2)} ms`, `color: ${color}; font-weight: normal`);
            return result;
        };

        wrappedFn._isWrapped = true;
        return wrappedFn;
    },

    deepWrapFunctions(obj, prefix = "", visited = new Set()) {
        if (!obj || typeof obj !== "object") return;

        if (visited.has(obj)) return;
        visited.add(obj);

        const exclude = [
            "constructor",
            "destroy",
            "_debugWrap",
            "_wrapObjectMethodsForDebugging",
            "deepWrapFunctions",
            "formatNumber",
            "expandTags"
        ];

        if (obj instanceof HTMLElement || obj instanceof Window || obj instanceof Document || (typeof jQuery !== "undefined" && obj instanceof jQuery)) {
            return;
        }

        for (const key in obj) {
            try {
                const val = obj[key];

                if (typeof val === "function" && !exclude.includes(key)) {
                    if (!val._isWrapped) {
                        obj[key] = this._debugWrap(val, `${prefix}${key}`);
                    }
                } else if (typeof val === "object" && val !== null) {
                    this.deepWrapFunctions(val, `${prefix}${key}.`, visited);
                }
            } catch (e) {
                console.warn(`deepWrapFunctions error on ${prefix}${key}:`, e);
            }
        }
    },

    _wrapObjectMethodsForDebugging(obj, prefix = "") {

        // exclude some functions, which are not important
        const exclude = [
            "constructor",
            "destroy",
            "_debugWrap",
            "_wrapObjectMethodsForDebugging",
            "formatNumber",
            "expandTags"
        ];

        for (const key in obj) {
            if (
                typeof obj[key] === "function" &&
                !exclude.includes(key)
            ) {
                const fn = obj[key];
                obj[key] = this._debugWrap(fn, `${prefix}${key}`);
            }
        }
    },

    destroy: function () {
     
        //this.element.off("DOMSubtreeModified");
      
        //this.element.destroyObjects();
        this.element
            .removeClass()
            .html("");
      
        this.element.vcInvoke("destroy");
    }
});


////-----------------------------------------------STRUCTURE OF NEW WIDGET-----------------------------------------------------
////--------------------------------just copy, fill the gaps and create functions if you need----------------------------------




// /**
//  * param in string is the namespace and the name of the function that you create 
//  * example: bluaul.visual -> $("div#visual").visual();
//  */
//$.widget("bluaul.visual", $.common.Visual, {
//    _create: function () {
//        try {
//            /**
//            * set the Visual-Name HARDCODED first
//            * after that execute the parent function (_super())
//            * to load the visual into the root-element
//            */
//            this.options.name = "VISUAL_NAME";
//            //NOTE: later on the vcvid(VisualID) is set - increases speed of execution
//            this._super(); //execute function of parent -> execute vcInvoke to init visual html and get the visual data into the visual
//        } catch (ex) { this.writeError('initEvents', ex); return false; }
//        return true;
//    },
//    /**
//     * init split in two functions
//     * one for final initialization of elements(_initHTML())
//     * the other one to bind events and functions(_initEvents())
//     */
//    _initHTML: function () {
//        //var me = this;
//        try {
//            /**
//             * create and complete html markup
//             */
//        } catch (ex) { this.writeError('_initHTML', ex); return false; }
//        return true;
//    },
//    _initEvents: function () {
//        //var me = this;
//        try {
//            /**
//             * bind events to elements
//             */
//        } catch (ex) { this.writeError('_initEvents', ex); return false; }
//        return true;
//    },
//    _privateFunction: function () {
//        //var me = this;
//        try {
//            /**
//             * private function starts with _
//             */
//        } catch (ex) { this.writeError('_privateFunction', ex); return false; }
//        return true;
//    },
//    publicFunction: function () {
//        //var me = this;
//        try {
//            /**
//             * public function that can be used over $("#foo").visual("publicFunction")
//             */
//        } catch (ex) { this.writeError('publicFunction', ex); return false; }
//        return true;
//    }
//});
